<template>
  <svg
    fill="currentColor"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 297 297"
    xml:space="preserve"
  >
    <path
      d="M276.955,114.128h-11.421c-3.076-53.545-42.247-97.577-93.496-108.064C170.499,2.498,166.953,0,162.822,0h-28.645
        c-4.131,0-7.676,2.498-9.216,6.064C73.714,16.551,34.543,60.583,31.467,114.128H20.045c-5.542,0-10.036,4.493-10.036,10.036v30.496
        c0,5.542,4.493,10.036,10.036,10.036h16.273v0.002c0,6.732,0.607,13.437,1.806,20.02l-15.4,8.892
        c-2.305,1.331-3.987,3.522-4.676,6.094c-0.689,2.571-0.328,5.31,1.003,7.615l27.171,47.06c2.772,4.799,8.908,6.446,13.709,3.673
        l15.421-8.903c10.251,8.723,22.029,15.534,34.656,20.038v17.778c0,5.542,4.493,10.036,10.036,10.036h54.341
        c5.542,0,10.036-4.493,10.036-10.036v-17.778c12.627-4.504,24.405-11.315,34.657-20.038l15.421,8.903
        c4.802,2.772,10.938,1.126,13.709-3.673l27.17-47.06c2.772-4.8,1.127-10.937-3.673-13.709l-15.4-8.892
        c1.201-6.583,1.807-13.288,1.807-20.02v-0.002h18.847c5.542,0,10.036-4.493,10.036-10.036v-30.496
        C286.991,118.622,282.497,114.128,276.955,114.128z M152.787,20.071v65.863h-8.573V20.071H152.787z M81.175,50.937V95.97
        c0,5.542,4.493,10.036,10.036,10.036s10.036-4.493,10.036-10.036V36.055c7.128-3.984,14.812-7.081,22.896-9.176V95.97
        c0,5.542,4.493,10.036,10.036,10.036h28.645c5.542,0,10.036-4.493,10.036-10.036V26.879c8.084,2.095,15.768,5.192,22.897,9.176
        V95.97c0,5.542,4.493,10.036,10.036,10.036c5.542,0,10.036-4.493,10.036-10.036V50.938c16.852,16.214,27.858,38.443,29.578,63.19
        H51.597C53.317,89.38,64.324,67.152,81.175,50.937z M238.037,164.697c0,7.638-0.95,15.229-2.823,22.562
        c-1.114,4.358,0.81,8.926,4.705,11.175l13.056,7.538l-17.134,29.678l-13.083-7.553c-3.899-2.25-8.819-1.631-12.036,1.517
        c-10.922,10.685-24.42,18.489-39.037,22.568c-4.338,1.21-7.338,5.163-7.338,9.666v15.079h-34.27V261.85c0-4.503-3-8.456-7.338-9.666
        c-14.617-4.079-28.115-11.883-39.036-22.567c-3.217-3.15-8.139-3.767-12.036-1.518l-13.083,7.553L41.45,205.973l13.057-7.538
        c3.896-2.249,5.819-6.816,4.705-11.175c-1.874-7.334-2.823-14.924-2.823-22.562v-0.002h30.86v0.002
        c0,33.064,26.899,59.964,59.964,59.964s59.964-26.899,59.964-59.964v-0.002h30.86V164.697z M159.243,164.697
        c0,6.634-5.397,12.031-12.031,12.031s-12.031-5.397-12.031-12.031l0-0.002h24.062L159.243,164.697z M147.212,196.799
        c17.701,0,32.102-14.401,32.102-32.102v-0.002h7.791v0.002c0,21.997-17.896,39.892-39.893,39.892s-39.892-17.895-39.892-39.892
        v-0.002h7.79v0.002C115.11,182.398,129.511,196.799,147.212,196.799z M266.92,144.624H30.08v-10.425H266.92V144.624z"
    />
  </svg>
</template>
